<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>设备批量清空</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.mac" @keyup.enter.native="clicksearch" placeholder="请输入MAC地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
         <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择处理状态" value="-1"></el-option>
              <el-option label="待处理" value="0"></el-option>
              <el-option label="已处理" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
             <el-select v-model="keywords.result" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option label="请选择处理结果" value="-1"></el-option>
               <el-option label="待处理" value="0"></el-option>
               <el-option label="处理成功" value="1"></el-option>
               <el-option label="处理失败" value="2"></el-option>
             </el-select>
           </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="danger" @click="ProcessDeviceClearPlLiang" v-if="SubRule_Device_AddPlLiangProcess">批量审核</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="8%"></el-table-column>
          <el-table-column prop="Mac" label="MAC地址" min-width="10%"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="BomsnName" label="设备类型" min-width="8%"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型" min-width="8%"></el-table-column>
          <el-table-column prop="StatusName" label="导入状态" min-width="8%"></el-table-column>
          <el-table-column prop="ResultName" label="导入结果" min-width="8%"></el-table-column>
          <el-table-column prop="Note" label="备注" min-width="14%"></el-table-column>
          <el-table-column prop="Userid1Name" label="导入人" min-width="8%"></el-table-column>
          <el-table-column prop="Userid2Name" label="操作人" min-width="8%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 批量清空 start -->
      <el-tab-pane label="批量清空">
        <el-form :model="addDevice" ref="addDeviceRef" label-width="75px">
          <el-form-item label="MAC" class="addAdminForm">
            <el-input type="textarea" :rows="10" v-model="addDevice.maclist" placeholder="请复制多行MAC地址进来."></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 批量清空 end -->
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyDeviceBatchClear',
  data () {
    return {
      activeName: 'first',
      bomSnList: [],
      saleTypeList: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        mac: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        bomsn: '',
        saletype: '0',
        status: '-1',
        result: '-1'
      },
      // 添加设备
      addDevice: {
        maclist: ''
      },
      SubRule_Device_AddPlLiangProcess: false
    }
  },
  mounted () {
    this.GetDeviceClearPlLiangnum()
    this.GetDeviceClearPlLianglist()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_AddPlLiangProcess', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_AddPlLiangProcess = true
      }
    })
  },
  methods: {
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetDeviceClearPlLianglist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetDeviceClearPlLiangnum()
      this.GetDeviceClearPlLianglist()
    },
    clickadd () {
      this.AddDeviceClearPlLiang()
    },
    GetDeviceClearPlLianglist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        status: that.keywords.status,
        result: that.keywords.result
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDeviceClearPlLianglist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetDeviceClearPlLiangnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        status: that.keywords.status,
        result: that.keywords.result
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDeviceClearPlLiangnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddDeviceClearPlLiang: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        maclist: that.addDevice.maclist
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddDeviceClearPlLiang, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addDevice.maclist = ''
            that.GetDeviceClearPlLiangnum()
            that.GetDeviceClearPlLianglist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    ProcessDeviceClearPlLiang: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ProcessDeviceClearPlLiang, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetDeviceClearPlLiangnum()
            that.GetDeviceClearPlLianglist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
